<template>
  <div class="gx-uc">
    <top-banner
      :nav-items="navItems"
      :unread="unreadCount"
      @logo="goHome"
      @nav="onNav"
      @bell="goNotification"
      @legacy="goLegacy"
      @logout="logout"
    />

    <div class="gx-uc__content">
      <!-- 欢迎横幅 -->
      <div class="gx-uc__welcome">
        <div class="gx-uc__welcome-left">
          <span class="gx-uc__avatar">
            <img v-if="userinfo.avatar" :src="userinfo.avatar" alt="" />
            <template v-else>{{ avatarText }}</template>
          </span>
          <div>
            <div class="gx-uc__greet">
              <span class="gx-uc__greet-name">{{ greeting }}，{{ userinfo.nickname || userinfo.name || userinfo.mobile }}</span>
              <span class="gx-uc__vip">{{ levelText }}</span>
            </div>
            <div class="gx-uc__slogan">AI智能店群运营 · 致力店群无人化</div>
          </div>
        </div>
        <div class="gx-uc__date">{{ dateStr }}</div>
      </div>

      <!-- 汇总卡片 -->
      <div v-if="summary.length" class="gx-uc__summary">
        <div
          v-for="(s, i) in summary"
          :key="s.label"
          class="gx-uc__sum-card"
          @mouseenter="hovSum = i"
          @mouseleave="hovSum = -1"
        >
          <span class="gx-uc__sum-icon" :style="sumIconStyle(s, i)">{{ s.icon }}</span>
          <div>
            <div class="gx-uc__sum-value" :style="{ color: s.color }">{{ s.prefix }}{{ s.display }}</div>
            <div class="gx-uc__sum-label">{{ s.label }}</div>
          </div>
        </div>
      </div>

      <!-- 工作台选择 -->
      <div class="gx-uc__wb">
        <div class="gx-uc__section-title">选择工作台</div>

        <div v-if="!hasNewUiPermission" class="gx-uc__no-permission">
          <div class="gx-uc__no-permission-title">当前岗位暂无新版菜单权限</div>
          <div class="gx-uc__no-permission-desc">请联系主账号在新版岗位管理中配置权限，或进入旧系统使用原有权限。</div>
          <button class="gx-uc__no-permission-btn" @click="goLegacy">进入旧系统</button>
        </div>

        <div v-else class="gx-uc__wb-grid">
          <div
            v-for="(wb, i) in visibleWbs"
            :key="wb.id"
            class="gx-uc__wb-card"
            @mouseenter="hovWb = i"
            @mouseleave="hovWb = -1"
            @click="enterWb(wb)"
          >
            <div class="gx-uc__wb-head">
              <span class="gx-uc__wb-icon" :style="wbIconStyle(wb, i)">{{ wb.icon }}</span>
              <div>
                <div class="gx-uc__wb-name" :style="{ color: hovWb === i ? wb.color : '#1A1A2E' }">{{ wb.name }}</div>
                <div class="gx-uc__wb-desc">{{ wb.desc }}</div>
              </div>
            </div>
            <div class="gx-uc__wb-tags">
              <span
                v-for="(tag,ti) in wb.tags"
                :key="ti"
                class="gx-uc__wb-tag"
                :style="{ color: hovWb === i ? wb.color : '#6A6A8A', borderColor: hovWb === i ? wb.color + '30' : 'rgba(0,0,0,.06)' }"
              >{{ tag }}</span>
            </div>
            <span class="gx-uc__wb-beam" :style="{ background: `linear-gradient(90deg,${wb.color},${wb.color}50,transparent)` }"></span>
          </div>
        </div>

        <!-- 系统工作台 -->
        <div v-if="showSystemWorkbench" class="gx-uc__sys" @mouseenter="hovSys = true" @mouseleave="hovSys = false" @click="enterWb(visibleSysWb)">
          <div class="gx-uc__sys-left">
            <span class="gx-uc__sys-icon">⚙️</span>
            <div>
              <div class="gx-uc__sys-name">{{ visibleSysWb.name }}</div>
              <div class="gx-uc__sys-desc">{{ visibleSysWb.desc }}</div>
            </div>
            <div class="gx-uc__sys-tags">
              <span v-for="tag in visibleSysWb.tags" :key="tag" class="gx-uc__sys-tag">{{ tag }}</span>
            </div>
          </div>
          <span class="gx-uc__sys-cta">进入系统设置 →</span>
        </div>
      </div>

      <!-- 待办提醒 -->
      <div v-if="todoCols.length" class="gx-uc__todo">
        <div class="gx-uc__todo-head">
          <span class="gx-uc__section-title">待办 &amp; 提醒</span>
          <button class="gx-uc__todo-more" @click="goNotification">查看全部 →</button>
        </div>
        <div class="gx-uc__todo-grid">
          <div v-for="col in todoCols" :key="col.tab" class="gx-uc__todo-col">
            <div class="gx-uc__todo-col-head">{{ col.tab }}</div>
            <div class="gx-uc__todo-items">
              <div v-for="item in col.items" :key="item.t" class="gx-uc__todo-item">
                <span class="gx-uc__todo-dot" :style="{ background: item.c, boxShadow: `0 0 6px ${item.c}80` }"></span>
                <div class="gx-uc__todo-body">
                  <div class="gx-uc__todo-text">{{ item.t }}</div>
                  <div class="gx-uc__todo-time">{{ item.time }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import TopBanner from '../../components/newUi/TopBanner.vue'
import { workbenchSummary } from '../../api/main/ucenter'
import { getAllowedChildren, getAllowedWorkbenches, isHostAccount, parsePermissionKeys } from '../../config/newUiPermissions'

const NAV = [
  { id: null, label: '星人工作台', active: true },
  // { id: 'agent', label: 'Agent工作台' },
  { id: 'shop', label: '店铺工作台' },
  { id: 'finance', label: '财务工作台' },
  { id: 'ops', label: '运营工作台' },
  // { id: 'select', label: '选品工作台' },
  { id: 'cloud', label: '云库工作台' },
  // { id: 'goods', label: '商品工作台' },
  { id: 'presales', label: '售前工作台' },
  { id: 'aftersales', label: '售后工作台' },
  { id: 'system', label: '系统工作台' }
]

const WBS = [
  { id: 'agent',icon: '🏬', name: 'Agent工作台', desc: '抖店自动化+微店自动化', color: '#9B8AFB', tags: ['设置Agent流程', '自动化监控', '自动化管理'], route: null ,coming: true},
  { id: 'shop', icon: '🏪', name: '店铺工作台', desc: '店铺管理+商品管理+批量优化', color: '#D4A946', tags: ['抖店列表', '微店列表', '商品管理', '批量修改', 'AI检测' ,'AI生图', 'AI优化'], route: '/new_uc_shop_manage' },
  { id: 'finance', icon: '💰', name: '财务工作台', desc: '收支+对账+报销+钱包', color: '#22C55E', tags: [], route: '/new_finance_workbench' },
  { id: 'ops', icon: '📊', name: '运营工作台', desc: '看板+任务+排行+策略', color: '#3FB6E0', tags: [], route: '/new_ops_workbench' },
  { id: 'select', icon: '🔍', name: '选品工作台', desc: '选类目+选词+选品', color: '#F59E0B', tags: ['AI定方向', 'AI找同款', '抖店选品', '1688选品'], route: '/new_select_workbench',coming: true },
  { id: 'cloud', icon: '☁️', name: '云库工作台', desc: '入库管理+批量修改+AI优化+自动上货', color: '#8B5CF6', tags: ['云商品库', 'AI检测', 'AI找货源', 'AI生图',
      '批量修改', '上架策略', '多平台自动上货'], route: '/new_cloud_workbench' },
  // { id: 'goods', icon: '📦', name: '商品工作台', desc: '管货+优化+检测+合规', color: '#9B8AFB', tags: ['我的商品', '商品优化', '检测管理'], route: '/new_goods_workbench' },
  { id: 'presales', icon: '🛒', name: '售前工作台', desc: '多平台自动采购+多平台订单处理', color: '#EC4899', tags: ['抖店订单', '微店订单'], route: '/new_presales_workbench' },
  { id: 'aftersales', icon: '🛡️', name: '售后工作台', desc: '多平台售后处理+自动获取退货地址', color: '#14B8A6', tags: ['抖店售后', '售后配置', '微店售后', '售后配置'], route: '/new_aftersales_workbench' }
]

const SYS = {
  id: 'system', icon: '⚙️', name: '系统工作台',
  desc: '工单提交+账号管理+账号设置',
  color: '#FB923C',
  tags: ['工单管理', '岗位管理', '员工管理', '个人设置','观星树插件端', '观星树客户端'],
  route: '/new_system_workbench'
}

export default {
  name: 'NewUcenterPage',
  components: { TopBanner },
  data() {
    return {
      navItems: NAV.map((n) => ({ ...n })),
      wbs: WBS,
      sysWb: SYS,
      hovSum: -1,
      hovWb: -1,
      hovSys: false,
      loading: true,
      shopCount: null,
      goodsCount: null,
      purchaseToday: null,
      profitToday: null,
      orderTotal: null,
      cloudTotal: null,
      notificationCount: 0,
      now: new Date()
    }
  },
  computed: {
    userinfo() {
      return this.$store.state.login.userinfo || {}
    },
    levelText() {
      const level = this.$store.state.login.user_level
      if (level === 1) return '企业版会员'
      // if (level === 2) return '企业版会员'
      return '普通会员'
    },
    avatarText() {
      const name = this.userinfo.nickname || this.userinfo.name || ''
      return name ? name[0] : '星'
    },
    greeting() {
      const hour = new Date().getHours()
      return hour < 12 ? '早上好' : hour < 18 ? '下午好' : '晚上好'
    },
    dateStr() {
      const d = new Date()
      const days = ['日', '一', '二', '三', '四', '五', '六']
      return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日 星期${days[d.getDay()]}`
    },
    summary() {
      return [
        { permission: ['shop.douyin', 'shop.wechat'], label: '总店铺', icon: '🏪', color: '#C8443C', prefix: '', display: this.formatNumber(this.shopCount) ?? '--' },
        { permission: ['goods.douyin_manage', 'goods.wechat_manage'], label: '在售商品', icon: '📦', color: '#C8443C', prefix: '', display: this.formatNumber(this.goodsCount) ?? '--' },
        { permission: ['finance.shop_data'], label: '今日采购额', icon: '💰', color: '#C8443C', prefix: '¥', display: this.formatNumber(this.purchaseToday) ?? '--' },
        { permission: ['finance.shop_data'], label: '今日利润', icon: '📈', color: '#C8443C', prefix: '¥', display: this.formatNumber(this.profitToday) ?? '--' }
      ].filter((item) => this.hasPermission(item.permission))
    },
    allowedWorkbenches() {
      return getAllowedWorkbenches(this.userinfo.new_ui_access, this.$store.state.login.is_host)
    },
    visibleWbs() {
      const allowedIds = new Set(this.allowedWorkbenches.map((item) => item.id))
      return this.wbs.filter((item) => allowedIds.has(item.id)).map((item) => ({
        ...item,
        tags:item?.tags?.length?item.tags: getAllowedChildren(item.id, this.userinfo.new_ui_access, this.$store.state.login.is_host).map((child) => child.label)
      }))
    },
    showSystemWorkbench() {
      return this.allowedWorkbenches.some((item) => item.id === 'system')
    },
    visibleSysWb() {
      return {
        ...this.sysWb,
        tags: getAllowedChildren('system', this.userinfo.new_ui_access, this.$store.state.login.is_host).map((child) => child.label)
      }
    },
    hasNewUiPermission() {
      return this.allowedWorkbenches.length > 0
    },
    unreadCount() {
      const notifs = this.$store.state.notification.notifications || []
      return notifs.filter((n) => !n.isRead).length
    },
    todoCols() {
      const orderTotal = this.formatNumber(this.orderTotal)
      const cloudTotal = this.formatNumber(this.cloudTotal)
      const goodsCount = this.formatNumber(this.goodsCount)
      return [
        {
          tab: '待办任务',
          items: [
            { permission: ['presales.douyin_order'], t: orderTotal === null ? '暂无待办任务数据' : `${orderTotal} 笔订单待处理`, time: '实时', c: '#C8443C' },
            { permission: ['ops.task'], t: '更多任务请前往任务大厅', time: '运营工作台', c: '#3FB6E0' }
          ].filter((item) => this.hasPermission(item.permission))
        },
        {
          tab: '交易提醒',
          items: [
            { permission: ['presales.douyin_order'], t: orderTotal === null ? '暂无订单数据' : `${orderTotal} 笔订单待确认`, time: '订单管理', c: '#C8443C' },
            { permission: ['cloud.library'], t: cloudTotal === null ? '暂无云库数据' : `云商品库共 ${cloudTotal} 件`, time: '云库工作台', c: '#22C55E' }
          ].filter((item) => this.hasPermission(item.permission))
        },
        {
          tab: '商品提醒',
          items: [
            { permission: ['goods.douyin_manage', 'goods.wechat_manage'], t: goodsCount === null ? '暂无商品数据' : `在售商品 ${goodsCount} 件`, time: '商品工作台', c: '#D4A946' },
            { permission: ['cloud.detect'], t: '检测异常请前往检测管理', time: '检测管理', c: '#FB923C' }
          ].filter((item) => this.hasPermission(item.permission))
        }
      ].filter((column) => column.items.length)
    }
  },
  created() {
    if (this.$route.query.legacy_permission === 'none') {
      this.$nextTick(() => this.$message({ message: '当前岗位暂无旧版菜单权限', type: 'warning' }))
    }
    this.loadData()
  },
  methods: {
    ...mapMutations({
      OUT_LOGIN: 'login/OUT_LOGIN'
    }),
    hasPermission(keys) {
      if (isHostAccount(this.$store.state.login.is_host)) return true
      const access = new Set(parsePermissionKeys(this.userinfo.new_ui_access))
      return keys.some((key) => access.has(key))
    },
    formatNumber(value) {
      if (value === null || value === undefined || value === '') return null
      const number = Number(value)
      return Number.isFinite(number) ? number.toLocaleString() : null
    },
    loadData() {
      // 通知未读数
      this.$store.dispatch('notification/initNotificationWS')

      const canReadSummary = this.hasPermission([
        'shop.douyin',
        'shop.wechat',
        'goods.douyin_manage',
        'goods.wechat_manage',
        'finance.shop_data'
      ])

      if (canReadSummary) {
        workbenchSummary().then((res) => {
          if (res.code === 200 && res.data) {
            if (this.hasPermission(['shop.douyin', 'shop.wechat'])) {
              this.shopCount = res.data.shop_count ?? 0
            }
            if (this.hasPermission(['goods.douyin_manage', 'goods.wechat_manage'])) {
              this.goodsCount = res.data.goods_count ?? 0
            }
            if (this.hasPermission(['finance.shop_data'])) {
              this.purchaseToday = res.data.purchase_today ?? 0
              this.profitToday = res.data.profit_today ?? 0
            }
          }
        }).catch(() => {})
      }
    },
    sumIconStyle(s, i) {
      return {
        background: `${s.color}12`,
        border: `2px solid ${s.color}28`,
        transform: this.hovSum === i ? 'scale(1.1)' : 'scale(1)'
      }
    },
    wbIconStyle(wb, i) {
      return {
        background: `${wb.color}12`,
        border: `2px solid ${wb.color}35`,
        filter: this.hovWb === i ? `drop-shadow(0 0 8px ${wb.color}80)` : undefined,
        transform: this.hovWb === i ? 'scale(1.08)' : 'scale(1)'
      }
    },
    onNav(id) {
      if (id === null) return
      const map = {
        agent: null,
        shop: '/new_uc_shop_manage',
        finance: '/new_finance_workbench',
        ops: '/new_ops_workbench',
        select: '/new_select_workbench',
        cloud: '/new_cloud_workbench',
        goods: '/new_goods_workbench',
        presales: '/new_presales_workbench',
        aftersales: '/new_aftersales_workbench',
        system: '/new_system_workbench'
      }
      const route = map[id]
      if (!route) {
        this.$message({ message: '该工作台功能开发中，敬请期待', type: 'warning' })
        return
      }
      this.$router.push(route)
    },
    enterWb(wb) {
      if(wb.coming){
        this.$message({ message: '该工作台功能开发中，敬请期待', type: 'warning' })
        return
      }
      this.$router.push(wb.route)
    },
    goHome() {
      this.$router.push('/')
    },
    goLegacy() {
      this.$router.push('/ucenter_legacy')
    },
    goNotification() {
      this.$router.push('/notification')
    },
    logout() {
      this.OUT_LOGIN()
      this.$message({ message: '已退出登录', type: 'success' })
      location.href = '/'
    }
  }
}
</script>

<style scoped>
.gx-uc {
  min-height: 100vh;
  background: #F0F2F8;
  font-family: 'Noto Sans SC', sans-serif;
  overflow-x: hidden;
}
.gx-uc__content {
  padding: 20px 28px;
  max-width: 1440px;
  margin: 0 auto;
}
.gx-uc__welcome {
  border-radius: 12px;
  background: #FFFFFF;
  border: 2px solid #E0E0EC;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
  padding: 18px 24px;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.gx-uc__welcome-left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.gx-uc__avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: linear-gradient(135deg, #D4A946, #00D4FF);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
  overflow: hidden;
}
.gx-uc__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-uc__greet {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}
.gx-uc__greet-name {
  font-family: 'Noto Serif SC', serif;
  font-size: 22px;
  font-weight: 700;
  color: #D4A946;
}
.gx-uc__vip {
  padding: 2px 10px;
  border-radius: 10px;
  border: 1.5px solid rgba(212, 169, 70, .38);
  background: rgba(212, 169, 70, .06);
  font-size: 11px;
  font-weight: 700;
  color: #D4A946;
}
.gx-uc__slogan {
  font-size: 13px;
  color: #4A4A6A;
}
.gx-uc__date {
  font-family: Inter, monospace;
  font-size: 13px;
  color: #6A6A8A;
}
.gx-uc__summary {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-bottom: 18px;
}
.gx-uc__no-permission {
  padding: 44px 24px;
  border: 1px dashed #D8DCE8;
  border-radius: 14px;
  background: #FFFFFF;
  text-align: center;
}
.gx-uc__no-permission-title {
  color: #1A1A2E;
  font-size: 18px;
  font-weight: 600;
}
.gx-uc__no-permission-desc {
  margin-top: 8px;
  color: #6A6A8A;
  font-size: 13px;
}
.gx-uc__no-permission-btn {
  margin-top: 20px;
  padding: 9px 20px;
  border: 0;
  border-radius: 8px;
  background: #243470;
  color: #FFFFFF;
  cursor: pointer;
}
.gx-uc__sum-card {
  border-radius: 12px;
  padding: 20px 22px;
  cursor: default;
  background: #FFFFFF;
  border: 2px solid #E0E0EC;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
  display: flex;
  align-items: center;
  gap: 14px;
  transition: all .3s cubic-bezier(.4, 0, .2, 1);
}
.gx-uc__sum-card:hover {
  border-color: #D4A946;
  box-shadow: 0 4px 16px rgba(212, 169, 70, .2);
}
.gx-uc__sum-icon {
  width: 50px;
  height: 50px;
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  flex-shrink: 0;
  transition: transform .3s cubic-bezier(.4, 0, .2, 1);
}
.gx-uc__sum-value {
  font-family: Inter, 'JetBrains Mono', monospace;
  font-size: 32px;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 4px;
}
.gx-uc__sum-label {
  font-size: 14px;
  color: #4A4A6A;
}
.gx-uc__wb {
  margin-bottom: 18px;
}
.gx-uc__section-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 17px;
  font-weight: 700;
  color: #1A1A2E;
  margin-bottom: 12px;
}
.gx-uc__wb-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-bottom: 14px;
}
.gx-uc__wb-card {
  border-radius: 12px;
  padding: 18px 16px 14px;
  cursor: pointer;
  background: #FFFFFF;
  border: 2px solid #E0E0EC;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  transition: all .3s cubic-bezier(.4, 0, .2, 1);
}
.gx-uc__wb-card:hover {
  transform: translateY(-4px);
}
.gx-uc__wb-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}
.gx-uc__wb-icon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
  transition: all .3s cubic-bezier(.4, 0, .2, 1);
}
.gx-uc__wb-name {
  font-family: 'Noto Serif SC', serif;
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 2px;
  transition: color .3s cubic-bezier(.4, 0, .2, 1);
}
.gx-uc__wb-desc {
  font-size: 11px;
  color: #4A4A6A;
  line-height: 1.4;
}
.gx-uc__wb-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.gx-uc__wb-tag {
  padding: 2px 7px;
  border-radius: 6px;
  background: rgba(0, 0, 0, .04);
  border: 1px solid;
  font-size: 10px;
  transition: all .3s cubic-bezier(.4, 0, .2, 1);
}
.gx-uc__wb-beam {
  height: 2px;
  border-radius: 1px;
  margin-top: 10px;
  opacity: 0;
  transition: opacity .3s cubic-bezier(.4, 0, .2, 1);
}
.gx-uc__wb-card:hover .gx-uc__wb-beam {
  opacity: 1;
}
.gx-uc__sys {
  border-radius: 12px;
  padding: 14px 20px;
  cursor: pointer;
  background: #FFFFFF;
  border: 2px solid #E0E0EC;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  transition: all .3s cubic-bezier(.4, 0, .2, 1);
}
.gx-uc__sys:hover {
  border-color: #FB923C;
  box-shadow: 0 6px 22px rgba(251, 146, 60, .18);
  transform: translateY(-2px);
}
.gx-uc__sys-left {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}
.gx-uc__sys-icon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background: rgba(251, 146, 60, .07);
  border: 2px solid rgba(251, 146, 60, .21);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
}
.gx-uc__sys-name {
  font-family: 'Noto Serif SC', serif;
  font-size: 15px;
  font-weight: 700;
  color: #1A1A2E;
  margin-bottom: 2px;
}
.gx-uc__sys-desc {
  font-size: 11px;
  color: #4A4A6A;
}
.gx-uc__sys-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-left: 16px;
}
.gx-uc__sys-tag {
  padding: 3px 9px;
  border-radius: 6px;
  background: rgba(0, 0, 0, .04);
  border: 1px solid rgba(0, 0, 0, .07);
  font-size: 10px;
  color: #6A6A8A;
}
.gx-uc__sys-cta {
  flex-shrink: 0;
  padding: 8px 16px;
  border-radius: 8px;
  background: rgba(251, 146, 60, .08);
  border: 1px solid rgba(251, 146, 60, .3);
  font-size: 13px;
  font-weight: 600;
  color: #FB923C;
  white-space: nowrap;
}
.gx-uc__todo-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.gx-uc__todo-more {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 13px;
  color: #D4A946;
  padding: 0;
}
.gx-uc__todo-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  padding-bottom: 32px;
}
.gx-uc__todo-col {
  border-radius: 12px;
  background: #FFFFFF;
  border: 2px solid #E0E0EC;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
}
.gx-uc__todo-col-head {
  padding: 11px 16px;
  background: linear-gradient(135deg, rgba(212, 169, 70, .08), rgba(212, 169, 70, .02));
  border-bottom: 1px solid #F0F0EE;
  font-size: 14px;
  font-weight: 700;
  color: #D4A946;
}
.gx-uc__todo-items {
  padding: 6px 0;
}
.gx-uc__todo-item {
  padding: 10px 16px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: default;
  transition: background .3s cubic-bezier(.4, 0, .2, 1);
}
.gx-uc__todo-item:hover {
  background: #F5F0E8;
}
.gx-uc__todo-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 5px;
  animation: gx-pulse 1.8s ease-in-out infinite;
}
.gx-uc__todo-text {
  font-size: 14px;
  color: #1A1A2E;
  line-height: 1.5;
  font-weight: 500;
}
.gx-uc__todo-time {
  font-family: Inter, monospace;
  font-size: 11px;
  color: #6A6A8A;
  margin-top: 3px;
}
@media (max-width: 1100px) {
  .gx-uc__summary,
  .gx-uc__wb-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .gx-uc__todo-grid {
    grid-template-columns: 1fr;
  }
}
</style>
